import React, { useEffect, useState } from "react";

// Persistent-ish urgency countdown (resets per session start).
export function CountdownTimer({
  minutes = 15
}: {
  minutes?: number;
}) {
  const [remaining, setRemaining] = useState(() => {
    const stored = sessionStorage.getItem("bsm_deadline");
    if (stored) return Math.max(0, Math.floor((Number(stored) - Date.now()) / 1000));
    const deadline = Date.now() + minutes * 60 * 1000;
    sessionStorage.setItem("bsm_deadline", String(deadline));
    return minutes * 60;
  });
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(r => r > 0 ? r - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const m = String(Math.floor(remaining / 60)).padStart(2, "0");
  const s = String(remaining % 60).padStart(2, "0");
  const Box = ({
    v,
    l
  }: {
    v: string;
    l: string;
  }) => <div className="flex flex-col items-center" data-id="element-59" data-mp="34onwocamg9c7">
      <span className="min-w-[3rem] rounded-lg bg-slate-900 px-3 py-2 text-center font-display text-2xl font-extrabold tabular-nums text-white ring-1 ring-violet-500/40" data-id="element-60" data-mp="2zrfc65203t7s">
        {v}
      </span>
      <span className="mt-1 text-[10px] uppercase tracking-widest text-slate-400" data-id="element-61" data-mp="1h01lztilq76i">{l}</span>
    </div>;
  return <div className="flex items-center gap-3" role="timer" aria-live="off" data-id="element-62" data-mp="123k8owquqihb">
      <Box v={m} l="Min" data-id="element-63" data-mp="1712be5ea01gv" />
      <span className="pb-4 font-display text-2xl font-extrabold text-violet-400" data-id="element-64" data-mp="172dfk6bmvb8i">:</span>
      <Box v={s} l="Seg" data-id="element-65" data-mp="1us7rmlo4ovrp" />
    </div>;
}